import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../../lib/auth-context.js";
import { usePreferences } from "../../../lib/preferences.js";
import { getNetWorth } from "../../../lib/api-modules/networth.js";
import { CashFlowSparkline } from "../CashFlowSparkline.js";

/**
 * Phase 13.5 widget — 12-week projected cash sparkline.
 */
export function CashFlowSparklineWidget() {
  const { user } = useAuth();
  const { privacyMode } = usePreferences();
  const networthQuery = useQuery({
    queryKey: ["networth", "24m"],
    queryFn: () => getNetWorth("24m"),
    enabled: !!user,
  });
  const startingBalanceCents =
    networthQuery.data?.latest?.cash_cents ?? 0;
  return (
    <CashFlowSparkline
      hideValues={privacyMode}
      startingBalanceCents={startingBalanceCents}
    />
  );
}
